import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxPermissionsModule } from 'ngx-permissions';

// COMPONENTS
import { CoreModule } from '@app/core/core.module';
import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';

// MODULES
import { FilterModule } from '../filter/filter.module';
import { CanEditSalesOrderItemsPipe } from '../sales-order/pipes/can-edit-sales-order-items';
import { PipeModule } from '../shared/pipes/pipe.module';
import { UiModule } from '../ui/ui.module';

import { UomDisplayPipe } from './../../../app/shared/pipes/uom-display.pipe';
import { DirectiveModule } from './../shared/directives/directive.module';
import {
  RfqFormComponent,
  RfqProductInfoComponent,
  RfqKitItemsComponent,
  RfqAttachmentsComponent,
  RfqShipPackDetailsComponent,
  RfqOtherDetailsComponent,
  RfqListDropdownComponent,
  RfqVariantFormComponent,
  RfqProductSubstitutionComponent,
  RfqProductSubstitutionTableComponent,
  RfqProductSubstitutionFormComponent,
  RfqTableFormComponent,
  RfqLineItemsFormComponent,
  RfqLineItemsTableComponent,
  RfqScanModeInputComponent,
  RfqStatusComponent,
  RfqKitItemsAddFormComponent,
  RfqAssignBomFormComponent,
  RfqUomFormComponent,
  RfqQuantityFormComponent,
  RfqLotFormComponent,
  RfqSupplierSkusComponent,
  RfqSupplierSkusTableComponent,
  RfqTableFormV2Component,
  RfqInventoryOrdersTableComponent,
} from './components';
// PIPES
import { RfqImageBuilderPipe } from './pipes';

const components = [
  RfqFormComponent,
  RfqProductInfoComponent,
  RfqKitItemsComponent,
  RfqAttachmentsComponent,
  RfqShipPackDetailsComponent,
  RfqOtherDetailsComponent,
  RfqListDropdownComponent,
  RfqVariantFormComponent,
  RfqProductSubstitutionComponent,
  RfqProductSubstitutionTableComponent,
  RfqProductSubstitutionFormComponent,
  RfqTableFormComponent,
  RfqLineItemsFormComponent,
  RfqLineItemsTableComponent,
  RfqScanModeInputComponent,
  RfqStatusComponent,
  RfqKitItemsAddFormComponent,
  RfqAssignBomFormComponent,
  RfqUomFormComponent,
  RfqQuantityFormComponent,
  RfqLotFormComponent,
  RfqSupplierSkusComponent,
  RfqSupplierSkusTableComponent,
  RfqTableFormV2Component,
  RfqInventoryOrdersTableComponent,
];

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  AngularEditorModule,
  DragDropModule,
  CoreModule,
];

const lumModules = [
  SharedComponentsModule,
  PipeModule,
  MaterialCustomModule,
  UiModule,
  FilterModule,
  DirectiveModule,
  FeatureModule,
];

const pipes = [RfqImageBuilderPipe];

@NgModule({
  declarations: [...components, ...pipes],
  imports: [...angularModules, ...lumModules, NgxPermissionsModule, CanEditSalesOrderItemsPipe, UomDisplayPipe],
  exports: [...components, ...pipes],
  schemas: [NO_ERRORS_SCHEMA],
})
export class RfqModule {}
